import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import * as thunks from './thunks';
import { GetTaxCertificateListPayload, TaxCertificateState } from './types';
import { TaxCertificateListFilter } from './constants';

const initialState: TaxCertificateState = {
  isLoading: false,
  taxCertificateList: [],
  taxCertificateDetails: {},
  taxCertificateListMeta: {},
  taxCertificateListLinks: {},
  taxCertificateListFilterParams: {
    page: 1
  },
  taxCertificateColumn: TaxCertificateListFilter
};

const slice = createSlice({
  name: 'taxCertificate',
  initialState,
  reducers: {
    taxCertificateFilterParams(
      state,
      action: PayloadAction<GetTaxCertificateListPayload>
    ) {
      state.taxCertificateListFilterParams = action.payload || {};
    },
    clearTaxCertificateList(state) {
      state.taxCertificateList = [];
      state.taxCertificateListMeta = {};
      state.taxCertificateListLinks = {};
      state.isLoading = false;
    }
  },
  extraReducers(builder) {
    builder.addCase(thunks.taxCertificateListThunk.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(thunks.taxCertificateListThunk.rejected, (state) => {
      state.isLoading = false;
    });

    builder.addCase(thunks.taxCertificateDetailsThunk.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(
      thunks.taxCertificateListThunk.fulfilled,
      (state, { payload }) => {
        state.taxCertificateList = payload?.originalData?.data || [];
        state.taxCertificateListMeta = payload?.originalData?.meta || {};
        state.taxCertificateListLinks = payload?.originalData?.links || {};
        state.isLoading = false;
      }
    );

    builder.addCase(
      thunks.taxCertificateDetailsThunk.fulfilled,
      (state, { payload }) => {
        state.isLoading = false;
        state.taxCertificateDetails = payload?.originalData?.data || {};
      }
    );
  }
});

export const reducer = slice.reducer;
export const actions = { ...slice.actions, ...thunks };
